
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/common-room",
      function () {
        return require("private-next-pages/destinations/common-room.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/common-room"])
      });
    }
  